let env = {}
if (process.env.NODE_ENV === 'production')
{
    if (document.location.protocol == 'https:') {
        env = {
            PROD_ENV: '/admin/index.php/_api/',
            PROD_FRONT_ENV: '/entrance/index.php/_api/',
            PROD_IMG_ENV: '/admin/api/admin/index.php/_api/services/upload_service',
            IMG_URL_PREFIX: 'https://www.admin.ryiw.vip/',
            IMG_COMMON_REQUEST_URL_PREFIX: '/admin/index.php/_api/services/upload_admin_service',
            IMG_COMMON_URL_PREFIX: 'https://www.admin.ryiw.vip/uploads/',
            TEST_ENV: '/api',
            IM_SOCKET_URL: 'wss://www.ryiw.vip:8273',
            VERIFY_CODE_URL: 'https://www.admin.ryiw.vip/admin/index.php/_api/Captcha_code/image_code',
            MODE_ENV: 'admin',
        }
    } else {
        env = {
            PROD_ENV: '/admin/index.php/_api/',
            PROD_FRONT_ENV: '/entrance/index.php/_api/',
            PROD_IMG_ENV: '/admin/api/admin/index.php/_api/services/upload_service',
            IMG_URL_PREFIX: 'http://www.admin.ryiw.vip/',
            IMG_COMMON_REQUEST_URL_PREFIX: '/admin/index.php/_api/services/upload_admin_service',
            IMG_COMMON_URL_PREFIX: 'http://www.admin.ryiw.vip/uploads/',
            TEST_ENV: '/api',
            IM_SOCKET_URL: 'ws://www.ryiw.vip:8274',
            VERIFY_CODE_URL: 'http://www.admin.ryiw.vip/admin/index.php/_api/Captcha_code/image_code',
            MODE_ENV: 'admin',
        }
    }

} else if (process.env.NODE_ENV === 'test')
{
    env = {
        PROD_ENV: 'https://test.ryiw.vip/admin/index.php/_api/',
        PROD_FRONT_ENV: 'https://test.ryiw.vip/entrance/index.php/_api/',
        PROD_IMG_ENV: 'https://test.ryiw.vip/admin/api/admin/index.php/_api/services/upload_service',
        IMG_URL_PREFIX: 'https://test.ryiw.vip/',
        IMG_COMMON_REQUEST_URL_PREFIX: '/admin/index.php/_api/services/upload_admin_service',
        IMG_COMMON_URL_PREFIX: 'https://test.ryiw.vip/uploads/',
        TEST_ENV: '/api',
        IM_SOCKET_URL: 'wss://test.ryiw.vip:8274',
        VERIFY_CODE_URL: 'https://test.ryiw.vip/admin/index.php/_api/Captcha_code/image_code',
        MODE_ENV: 'test',
    }
} else if (process.env.NODE_ENV === 'apkenv')
{
    env = {
        PROD_ENV: process.env.VUE_APP_API_URL + 'admin/index.php/_api/',
        PROD_FRONT_ENV: process.env.VUE_APP_API_URL + 'entrance/index.php/_api/',
        PROD_IMG_ENV: process.env.VUE_APP_API_URL + 'admin/api/admin/index.php/_api/services/upload_service',
        IMG_URL_PREFIX: process.env.VUE_APP_API_URL ,
        IMG_COMMON_REQUEST_URL_PREFIX: process.env.VUE_APP_API_URL + 'admin/index.php/_api/services/upload_admin_service',
        IMG_COMMON_URL_PREFIX: process.env.VUE_APP_API_URL + 'uploads/',
        TEST_ENV: process.env.VUE_APP_API_URL + 'api',
        IM_SOCKET_URL: 'wss://www.ryiw.vip:8273',
        VERIFY_CODE_URL: process.env.VUE_APP_API_URL + 'admin/index.php/_api/Captcha_code/image_code',
        MODE_ENV: 'admin',
    }
}
else
{

    env = {
        PROD_ENV: 'http://admin.ryw.com:81/admin/index.php/_api/',
        PROD_FRONT_ENV: 'http://admin.ryw.com:81/entrance/index.php/_api/',
        PROD_IMG_ENV: 'http://admin.ryw.com:81/admin/api/admin/index.php/_api/services/upload_service',
        IMG_URL_PREFIX: 'http://admin.ryw.com:81/',
        IMG_COMMON_REQUEST_URL_PREFIX: 'http://admin.ryw.com:81/admin/index.php/_api/services/upload_admin_service',
        IMG_COMMON_URL_PREFIX: 'http://admin.ryw.com:81/uploads/',
        TEST_ENV: 'http://admin.ryw.com:81/api',
        IM_SOCKET_URL: 'ws://192.168.3.210:7676',
        VERIFY_CODE_URL: 'http://admin.ryw.com:81/admin/index.php/_api/Captcha_code/image_code',
        MODE_ENV: 'local',

    }
}
export default env;